import { render, staticRenderFns } from "./BuyBoxNotifyMeNew.vue?vue&type=template&id=d158a064&scoped=true"
import script from "./BuyBoxNotifyMeNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxNotifyMeNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxNotifyMeNew.vue?vue&type=style&index=0&id=d158a064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d158a064",
  null
  
)

export default component.exports